<div class="wrapper">
  <div class="kai-auth-container">    
    <app-authentication class="row nav_drawer" [toggleSideNav]="sideNavFlag" ></app-authentication>
  </div>
</div>